/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { StocksApiConfiguration as __Configuration } from '../stocks-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { CreateInventoryItemTypeCommand } from '../models/create-inventory-item-type-command';
import { UpdateInventoryItemTypeCommand } from '../models/update-inventory-item-type-command';
import { ListQueryResultInventoryItemTypeInfo } from '../models/list-query-result-inventory-item-type-info';
@Injectable({
  providedIn: 'root',
})
class ItemTypeService extends __BaseService {
  static readonly CreateItemTypePath = '/api/stock/item-types/create';
  static readonly GetUpdateItemTypePath = '/api/stock/item-types/{id}/update';
  static readonly UpdateItemTypePath = '/api/stock/item-types/{id}/update';
  static readonly DeleteItemTypePath = '/api/stock/item-types/{id}/delete';
  static readonly GetAllPath = '/api/stock/item-types';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param command undefined
   */
  CreateItemTypeResponse(command?: CreateInventoryItemTypeCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/stock/item-types/create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateItemType(command?: CreateInventoryItemTypeCommand): __Observable<null> {
    return this.CreateItemTypeResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateItemTypeResponse(id: string): __Observable<__StrictHttpResponse<UpdateInventoryItemTypeCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/stock/item-types/${id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateInventoryItemTypeCommand>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateItemType(id: string): __Observable<UpdateInventoryItemTypeCommand> {
    return this.GetUpdateItemTypeResponse(id).pipe(
      __map(_r => _r.body as UpdateInventoryItemTypeCommand)
    );
  }

  /**
   * @param params The `ItemTypeService.UpdateItemTypeParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateItemTypeResponse(params: ItemTypeService.UpdateItemTypeParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/stock/item-types/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `ItemTypeService.UpdateItemTypeParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateItemType(params: ItemTypeService.UpdateItemTypeParams): __Observable<null> {
    return this.UpdateItemTypeResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  DeleteItemTypeResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/stock/item-types/${id}/delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DeleteItemType(id: string): __Observable<null> {
    return this.DeleteItemTypeResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param params The `ItemTypeService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAllResponse(params: ItemTypeService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultInventoryItemTypeInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/stock/item-types`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultInventoryItemTypeInfo>;
      })
    );
  }
  /**
   * @param params The `ItemTypeService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * @return Success
   */
  GetAll(params: ItemTypeService.GetAllParams): __Observable<ListQueryResultInventoryItemTypeInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultInventoryItemTypeInfo)
    );
  }
}

module ItemTypeService {

  /**
   * Parameters for UpdateItemType
   */
  export interface UpdateItemTypeParams {
    id: string;
    command?: UpdateInventoryItemTypeCommand;
  }

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
  }
}

export { ItemTypeService }
